const InvestmentTypes = {
  property: 'property',
  mortgage: 'mortgage',
  financialAsset: 'financial_asset',
};

export default InvestmentTypes;
